<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDepartment'}" @click="switchView('getDepartment')"><a href="javascript:;">센터소개</a></li>
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDoctorList'}" @click="switchView('getDoctorList')"><a href="javascript:;">의료진소개</a></li>
            <li :class="{'tab-menu__item': true, 'active': mode == 'getLocation'}" @click="switchView('getLocation')" v-if=" $store.getters.getHost != 'H0009'"><a href="javascript:;">위치안내</a></li>
        </ul>
    </div>
    <div class="about" v-if="mode == 'getDepartment'">
        <div class="about__img">
            <swiper :pagination="true"  :modules="modules" :effect="'fade'" :autoplay="{ delay: 4000 }" :speed="500" class="subSwiper">
                <swiper-slide v-if="org && org[1] && $store.getters.getHost == 'H0008'">
                    <img :src="`/displayFile.do?attachNo=${org[1].attachNo}`" :alt="org[1].altValue || '이미지'">
                </swiper-slide>
                <swiper-slide v-if="org">
                    <img :src="`/displayFile.do?attachNo=${org[0].attachNo}`" :alt="org[0].altValue || '이미지'" >
                </swiper-slide>
            </swiper>
            <p class="about__line-text"></p>
        </div>
        <div class="about__text">
            <p class="about__desc" v-html="contents"></p>
        </div>
        <!-- <kr_QuickMenu :info="info"/> -->
    </div>

    <div class="contents" v-if="mode == 'getDoctorList'">
        <kr_DoctorCard :doctorList="doctorList"/>
    </div>

    <template v-if="mode == 'getLocation'">
        <div class="position" v-for="item in location" :key="item">
            <div class="position__text">
                <h3>{{item.floor.indexOf('B') > -1 ? '지하' + item.floor.replace('B', '') + '층' : 
                    item.floor.indexOf('F') > -1 ? item.floor.replace('F', '층') : ''}}</h3>
            </div>
            <div class="position__map">
                <!-- <img src="@/assets/resource/img/position_map.png" alt="3층 안내도"> -->
                <img :src="`/displayFile.do?attachNo=${item.attachBag.lookAroundPhoto[0].attachNo}`" :alt="item.attachBag.lookAroundPhoto[0].altValue" v-if="item.attachBag.lookAroundPhoto">
            </div>
        </div>
    </template>
    <kr_QuickMenu :info="info"/>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade } from 'swiper/modules';

export default{
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade],
        };
    },
    data() {
        return {
            mode: 'getDoctorList',
            deptCd: this.$route.query.deptCd || '',
            // 센터
            info: '',
            contents: '',
            // 의료진
            doctorList: '',
            // 위치안내
            location: [],
            floor: '',
            // 단체이미지
            org: '',
        }
    },
    methods: {
        switchView(mode){
            this.mode = mode
            // this[mode]()
        },
        getDepartment(){
            const param = {
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                langCd: this.$store.getters.getLang
            }
            this.axios.get(this.api.department.view, {params: param})
            .then(res => {
                this.info = res.data
                this.org = this.info?.orgAttach?.organizationImg
                this.contents = ''
                if(this.$store.getters.getHost != 'H0006' && res.data.deptInfo) this.contents = res.data.deptInfo + '<br><br>'
                if(res.data?.deptDetailList?.length > 0) this.contents += res.data.deptDetailList[0].contents
            })
        },
        getDoctorList(){
            const param = {
                startIndex: 1,
                pageRow: 999,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                orderType: 'deptSort',
                // deptType: 1
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                if(res.data.doctorTotCnt > 0){
                    this.doctorList = res.data.doctorList
                }

                // if(this.deptCd === 'mom001'){
                //     const hanyejin = {
                //         drName: '한예진',
                //         belong: '소아청소년과, 고위험 신생아 집중치료센터',
                //         drSid: 'TEMP001',
                //         deptCd: 'mom001',
                //         mainDeptCd: 'mom001',
                //         detailField: '소아청소년과 일반진료',
                //         img: 'none',
                //         staticData: true,
                //         doctorDeptList: [
                //             {deptCd: 'PGE'}
                //         ]
                //     }

                //     this.doctorList.push(hanyejin)
                // }

                if(this.deptCd === 'mom04'){
                    const leehyunah = {
                        drName: '이현아',
                        img: 'lha',
                        staticData: true
                    }

                    this.doctorList.push(leehyunah)
                    this.doctorList = [{ doctorList: this.doctorList, deptNm: '', deptCd: null }]
                }

                if(['mom01','mom001','mom02','mom03'].includes(this.deptCd)){
                    const data = this.doctorList
                    let deptKey = []
                    if(this.deptCd == 'mom01'){
                        deptKey = [
                            {doctorList: [], deptCd: 'OG', deptNm: '산부인과'},
                            {doctorList: [], deptCd: null, deptNm: '협의진료과'}
                        ]
                    }else if(this.deptCd == 'mom001'){
                        deptKey = [
                            {doctorList: [], deptCd: 'PGE', deptNm: '소아청소년과'},
                            {doctorList: [], deptCd: null, deptNm: '협의진료과'}
                        ]
                    }else if(this.deptCd == 'mom02'){
                        deptKey = [
                            {doctorList: [], deptCd: 'SACS', deptNm: '외과(중환자외과)'},
                            {doctorList: [], deptCd: 'OG', deptNm: '산부인과'},
                            {doctorList: [], deptCd: null, deptNm: '협의진료과'}
                        ]
                    }else if(this.deptCd == 'mom03'){
                        deptKey = [
                            // {doctorList: [], deptCd: 'VCS', deptNm: '심장혈관흉부외과'},
                            {doctorList: [], deptCd: 'UR', deptNm: '비뇨의학과'},
                            // {doctorList: [], deptCd: 'PGE', deptNm: '소아청소년과(외과)'}, 
                            {doctorList: [], deptCd: 'CCNS', deptNm: '신경외과'},
                            {doctorList: [], deptCd: 'EY', deptNm: '안과'},
                            {doctorList: [], deptCd: 'JOS', deptNm: '정형외과'}
                        ]
                    }

                    for(let i of data){
                        let found = false
                        for(let j of deptKey){
                            if(i.drSid == '1015387' && i.doctorDeptList[0].deptCd == 'PGE'){
                                break
                            }
                            if(i.doctorDeptList && i.doctorDeptList[0].deptCd == j.deptCd){
                                j.doctorList.push(i)
                                found = true
                                break
                            }
                        }

                        if(!found){
                            for(let j of deptKey){
                                if(j.deptCd == null){
                                    j.doctorList.push(i)
                                    break
                                }
                            }
                        }
                    }
                    this.doctorList = deptKey
                }

                if(['MYEL','CART','LYMP','LEUK','PED','TRAN','HEMO',"BHL"].includes(this.deptCd)){
                    const data = this.doctorList
                    let deptKey = []
                    if(this.deptCd == 'CART'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                            {doctorList: [], deptCd: 'IMD', deptNm: '감염내과'},
                        ]
                    }else if(this.deptCd == 'MYEL'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'PA', deptNm: '병리과'},
                            {doctorList: [], deptCd: 'TR', deptNm: '방사선종양학과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                        ]
                    }else if(this.deptCd == 'LYMP'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'TR', deptNm: '방사선종양학과'},
                            {doctorList: [], deptCd: 'PA', deptNm: '병리과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                        ]
                    }else if(this.deptCd == 'LEUK'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                        ]
                    }else if(this.deptCd == 'PED'){
                        deptKey = [
                            {doctorList: [], deptCd: 'PGE', deptNm: '혈액내과/소아청소년과'},
                            {doctorList: [], deptCd: 'PA', deptNm: '병리과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                        ]
                    }else if(this.deptCd == 'TRAN'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'IMD', deptNm: '감염내과'},
                            {doctorList: [], deptCd: 'LM', deptNm: '진단검사의학과'},
                        ]
                    }else if(this.deptCd == 'HEMO'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: 'RH', deptNm: '재활의학과'},
                            {doctorList: [], deptCd: "ETC" , deptNm: '간호/진료지원파트'},
                        ]
                    }else if(this.deptCd == 'BHL'){
                        deptKey = [
                            {doctorList: [], deptCd: 'BIMH', deptNm: '혈액내과'},
                            {doctorList: [], deptCd: "ETC" , deptNm: '연구파트'},
                        ]
                    }

                    for(let i of data){
                        let found = false
                        for(let j of deptKey){
                            if(this.deptCd != 'PED' && i.drSid == '1001705' && j.deptCd == 'BIMH'){
                                j.doctorList.push(i)
                                found = true
                                break
                            }
                            if(i.doctorDeptList && i.doctorDeptList[0].deptCd == j.deptCd){
                                j.doctorList.push(i)
                                found = true
                                break
                            }
                        }

                        if(!found){
                            for(let j of deptKey){
                                if(j.deptCd == null){
                                    j.doctorList.push(i)
                                    break
                                }
                            }
                        }
                    }
                    
                    if(this.deptCd === 'HEMO'){
                        const docList = [
                            {name: '진주연', drNameGlb: '진주연', belong: '혈액암병원 파트장', belongGlb: '혈액암병원 파트장', detailField: '', imageSrc: 'doctor-blood10.png' },
                            {name: '김현희', drNameGlb: '김현희', belong: '사회사업팀 파트장, 의료사회복지사', belongGlb: '사회사업팀 파트장, 의료사회복지사', detailField: '', imageSrc: 'doctor-blood17.png'},
                            {name: '주예진', drNameGlb: '주예진', belong: '사회사업팀, 의료사회복지사', belongGlb: '사회사업팀, 의료사회복지사', detailField: '', imageSrc: 'doctor-blood18.png'},
                            {name: '정향주', drNameGlb: '정향주', belong: '조혈모세포이식코디네이터', belongGlb: '조혈모세포이식코디네이터', detailField: '', imageSrc: 'doctor-blood09.png' },
                            {name: '안소연', drNameGlb: '안소연', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood-new03.png' },
                            {name: '전희원', drNameGlb: '전희원', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood-new02.png' },
                            {name: '사지선', drNameGlb: '사지선', belong: '영양사', belongGlb: '영양사', detailField: '', imageSrc: 'doctor-blood20.png' },
                            {name: '이민경', drNameGlb: '이민경', belong: '영양사', belongGlb: '영양사', detailField: '', imageSrc: 'doctor-blood24.png' }
                            /*{name: '고효원', drNameGlb: '고효원', belong: '영양사', belongGlb: '영양사', detailField: '', imageSrc: 'doctor-blood21.png' }*/
                        ]
                        for(let j of deptKey){
                            if(j.deptCd == "ETC"){
                                j.doctorList =  docList;
                                break
                            }
                        }
                    }

                    if(this.deptCd === 'BHL'){
                        const docList = [
                            // {name: '김은지', drNameGlb: '김은지', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: ''},
                            {name: '최아림', drNameGlb: '최아림', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: ''},
                            {name: '김소영', drNameGlb: '김소영', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: ''},
                            {name: '유영임', drNameGlb: '유영임', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: ''},
                            {name: '이현정', drNameGlb: '이현정', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: ''},
                            {name: '안지영', drNameGlb: '안지영', belong: '연구원', belongGlb: '연구원', detailField: '', imageSrc: ''},
                            /*{name: '이성경', drNameGlb: '이성경', belong: '연구원', belongGlb: '연구원', detailField: '', imageSrc: ''}*/
                        ]
                        for(let j of deptKey){
                            if(j.deptCd == "ETC"){
                                j.doctorList =  docList;
                                break
                            }
                        }
                    }

                    this.doctorList = deptKey
                }
                console.log(this.doctorList)
            })
        },
        getLocation(){
            const param = {
                deptCd: this.deptCd
            }
            this.axios.get(this.api.lookAround.deptLookAround, {params: param})
            .then(res => {
                this.location = []
                if(res.data?.length > 0) {
                    const list = res.data
                    for(let i of list){
                        if(i.parentPlaceNm == '본관'){
                            this.location.push(i)
                        }
                    }
                    this.floor = res.data[0].floor.replace('F', '층')
                    
                    const floorSort = (floor) => {
                        if (floor.startsWith('B')) {
                            return -parseInt(floor.substring(1))
                        }
                        if (floor.startsWith('F')) {
                            return parseInt(floor.substring(1))
                        }
                        return 0
                    }

                    this.location.sort(function(a, b) {
                        return floorSort(a.floor) - floorSort(b.floor);
                    })
                }
            })
        }
    },
    mounted() {
        if(!this.deptCd){
            alert("잘못된 접근입니다.")
            this.$router.push('/')
            return
        }
        
        this.getDepartment()
        this.getDoctorList()
        if(this.$store.getters.getHost != 'H0009') this.getLocation()
    },
    watch: {
        $route(to, from){
            if(to.path == from.path){
                this.mode = 'getDoctorList'
                this.deptCd = to.query.deptCd,
                this.getDepartment()
                this.getDoctorList()
                if(this.$store.getters.getHost != 'H0009') this.getLocation()
            }
        }
    },
}
</script>